import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AldeiaPoloBaseDseiDto } from '../models/AldeiaPoloBaseDsei';
import { Dsei } from '../models/DSEI';
import { AldeiaDto } from '../models/aldeia';
import { PoloBaseDto } from '../models/polo-base';
import { BaseService } from './base.service';

type urlParam = string | number;

@Injectable({
  providedIn: 'root',
})
export class MapeamentoIndigenaService {
  constructor(private http: HttpClient, private baseService: BaseService) {}

  async listarDseiPorCodigoIbge(codIbge: string): Promise<Array<Dsei>> {
    let url = '/cnes/view-dsei?codigo-ibge=' + codIbge;
    return await this.baseService.get(url).toPromise();
  }

  async listarPoloBasePorCodigoIbgeEDsei(
    codIbge: string,
    codDsei: number
  ): Promise<Array<PoloBaseDto>> {
    let url =
      '/cnes/view-polo-base?codigo-ibge=' + codIbge + '&codigo-dsei=' + codDsei;
    return await this.baseService.get(url).toPromise();
  }
  async listarAldeiaPorCodigoIbgeEPoloBase(
    codIbge: string,
    codPoloBase: number
  ): Promise<Array<AldeiaDto>> {
    let url =
      '/cnes/view-aldeia?codigo-ibge=' +
      codIbge +
      '&codigo-polo-base=' +
      codPoloBase;
    return await this.baseService.get(url).toPromise();
  }

  async getAldeiaPoPoloBaseDseiPorCodAldeia(
    codigoAldeia: number
  ): Promise<AldeiaPoloBaseDseiDto> {
    let url = '/cnes/view-aldeia/aldeia-polo-base-dsei/' + codigoAldeia;
    return this.baseService.get(url).toPromise();
  }


  async getAldeiaById(codigoAldeia: urlParam) {
    const url = `/cnes/view-aldeia/${codigoAldeia}`;
    return this.baseService.get(url).toPromise();
  }

  async getPoloBaseById(poloBase: urlParam) {
    const url = `/cnes/view-polo-base/${poloBase}`;
    return this.baseService.get(url).toPromise();
  }

  async getDseiById(dsei: urlParam) {
    const url = `/cnes/view-dsei/${dsei}`;
    return this.baseService.get(url).toPromise();
  }


  async getMapeamentoByRascunho(id: string | number) {
    const url = `/cnes/dsei-polobase-aldeia/rascunho/${id}`;
    return this.baseService.get(url).toPromise();
  }

  async getMapeamentoByEstabelecimento(id: string | number) {
    const url = `/cnes/dsei-polobase-aldeia/estabelecimento/${id}`;
    return this.baseService.get(url).toPromise();
  }


}
